import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SaintVincentAndTheGrenadinesFlagIcon: FC<PropsWithChildren<Props>> = ({
	className,
}) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16246'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16246)'>
				<rect
					x='9.52344'
					width='10.4762'
					height='14'
					fill='#08C47A'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H6.66667V0H0V14Z'
					fill='#0C87E1'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.71484 14H14.2863V0H5.71484V14Z'
					fill='#FECB2F'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M6.66602 5.60005L8.09459 2.80005L9.52316 5.60005L8.09459 8.40005L6.66602 5.60005ZM10.4755 5.60005L11.9041 2.80005L13.3327 5.60005L11.9041 8.40005L10.4755 5.60005ZM9.99935 6.53338L8.57078 9.33338L9.99935 12.1334L11.4279 9.33338L9.99935 6.53338Z'
					fill='#08C47A'
				/>
			</g>
		</svg>
	);
};

export default SaintVincentAndTheGrenadinesFlagIcon;
